module.exports = __webpack_public_path__ + "static/img/bj_mzjg_icon10.png";